export enum InvestigationPlanErrorCode {
	AwaitingWrittenAnswers = "AWAITING_WRITTEN_ANSWERS",
	ValidationError = "VALIDATION_ERROR",
	PlanVersionConflict = "PLAN_VERSION_CONFLICT",
	MaxQuestionsReached = "MAX_QUESTIONS_REACHED",
	QuestionNotEditable = "QUESTION_NOT_EDITABLE",
}
